module.exports = __webpack_public_path__ + "large-house.c6de4b.png";